import { Button, Input, Space } from "antd";
import {
  SendOutlined,
  LoadingOutlined,
  LeftOutlined,
  RightOutlined,
} from "@ant-design/icons";
import "./FAQ.scss";
import api from "utils/api";
import { useEffect, useRef, useState } from "react";
// import { useDispatch } from "react-redux";
// import { setAiBotChatDetails } from "store/slice/aichat-slice";
import Loader from "Components/Loader";
import { useTranslation, Trans } from "react-i18next";
import { CONSTANTS } from "utils/constant";
import { PRIMARY_LANG, LANG_STYLD_EXT, TS_STYLD_COMPS } from "Common/constant";

const AIBotChat = ({
  isAiBotChatOpen,
  chatId,
  sltdFAQOption,
  faqDetails,
  retainedAiBotChatData,
  chatDetailsBckupRef,
  includePrimeLang
}) => {
  const [chatDetails, setChatDetails] = useState([]);
  const [optionsList, setOptionsList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sendingMsg, setSendingMsg] = useState(false);
  const [srchText, setSrchText] = useState(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(true);
  const containerRef = useRef(null);
  const endMessageFAQ = useRef(null);
  const optionsListRef = useRef(null);
  // const chatDetailsBckupRef = useRef(null);

  // const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const tgtLang = includePrimeLang
    ? i18n.language + "_" + PRIMARY_LANG
    : i18n.language;
  const tgtLangST = includePrimeLang ? tgtLang + LANG_STYLD_EXT : tgtLang;
  const handleScroll = () => {
    const container = containerRef.current;
    if (container) {
      setShowLeftArrow(container.scrollLeft > 0);
      setShowRightArrow(
        container.scrollLeft < container.scrollWidth - container.clientWidth
      );
    }
  };

  const handleArrowClick = (direction) => {
    const container = containerRef.current;
    if (container) {
      const scrollAmount = direction === "left" ? -250 : 250;
      container.scrollLeft += scrollAmount;
    }
  };

  const sendMessage = (item = null) => {
    let payload = {};
    if (item) {
      payload = {
        chat_id: chatId,
        chat_type: "bot",
        chat_category: item.category,
        page:item?.page|| 1,
      };
    } else {
      payload = {
        chat_id: chatId,
        chat_type: "ai",
        chat_message: srchText?.trim(),
      };
    }

    if (payload.chat_category || payload.chat_message) {
      setSendingMsg(true);
      let chatApi;
      if(payload.chat_type=="bot"){
        chatApi=api.get_chat_bot_message;        
      }else{
        chatApi=api.post_chat_message;
      }
      chatApi(payload)
        .then((res) => {          
          let data=res.data?.data;
          if(payload.chat_type=="bot"){
            data=res.data?.data?.results[0];
          }
          if (item) {
            if (data.text_response) {
              let details = [
                ...chatDetails,
                {
                  question: item.option,
                  answer: data.text_response,
                },
              ];
              chatDetailsBckupRef.current = details;
              setChatDetails(details);
            }
            let optionsArr=addPagination(payload,data);            
            setOptionsList(optionsArr);
            scrollToOptionsList();
          } else {
            let details = [
              ...chatDetails,
              {
                question: srchText,
                answer: data.text_response,
              },
            ];
            chatDetailsBckupRef.current = details;
            setChatDetails(details);
            setSrchText(null);
            setOptionsList([]);
            scrollToMessages();
          }
          setSendingMsg(false);
        })
        .catch(() => {
          setSendingMsg(false);
        });
    }
  };

  const scrollToOptionsList = () => {
    optionsListRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToMessages = () => {
    endMessageFAQ.current.scrollIntoView({ behavior: "smooth" });
  };

  const loadInitResults = () => {
    setLoading(true);
    let data = {
      chat_id: chatId,
      chat_type: "bot",
      chat_category: sltdFAQOption,
    };

    api
      .get_chat_bot_message(data)
      .then((res) => {
        let payload={chat_category: sltdFAQOption,}
        let optionsArr=addPagination(payload,res.data?.data?.results[0]);            
        setOptionsList(optionsArr);        
        setLoading(false);
        scrollToOptionsList();
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (!isAiBotChatOpen && sltdFAQOption) {
      loadInitResults();
    }

    // const handleBeforeUnload = (event) => {
    //   dispatch(
    //     setAiBotChatDetails({
    //       aiBotChatId: chatId,
    //       aiBotChatData: chatDetailsBckupRef.current,
    //       faqOptionsList: faqDetails,
    //     })
    //   );
    // };
    // window.addEventListener("beforeunload", handleBeforeUnload);

    if (retainedAiBotChatData?.length > 0) {
      setChatDetails(retainedAiBotChatData);
      chatDetailsBckupRef.current = retainedAiBotChatData;
    }
    const container = containerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }
    return () => {
      // dispatch(setAiBotChatData(chatDetailsBckupRef.current));
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
      // window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);
  function addPagination(payload, data) {
    let { has_more, buttons_responses } = data;
    let { chat_category, page = 1 } = payload;
    let pageOptions=[];    
    if(page >1){
      let PrevOptions = {
        "category": chat_category,
        "option": "<--Previous",
        page: page - 1,
      };
      pageOptions.push(PrevOptions);
    }
    if (has_more) {
      let moreOptions = {
        "category": chat_category,
        "option": "Next-->",
        page: page + 1,
      };
    pageOptions.push(moreOptions);
    }
      return [...buttons_responses,...pageOptions];    
  }
  return (
    <div className="chat-container">
      <div className="chat-wrapper-FAQ">
        <div className="message-container" id="message-container">
          {loading ? (
            <Loader tgtLangST={tgtLangST}/>
          ) : (
            <div className="chat-faq">
              {(chatDetails || []).map((chatItem, i) => {
                return (
                  <div
                    key={i}
                    ref={endMessageFAQ}
                    className="chatdetail-container"
                  >
                    <div className="question-txt-grid-item">
                      <div className="question-txt">{chatItem.question}</div>
                    </div>
                    <div className="answer-txt-grid-item">
                      <div className="answer-txt mt-16">{chatItem.answer}</div>
                    </div>
                    {/* <div className="question-txt">
                        <span>{chatItem.question}</span>
                      </div>
                      <div className="answer-txt">
                        <span>{chatItem.answer}</span>
                      </div> */}
                  </div>
                );
              })}
              <div
                ref={optionsListRef}
                className={`options-list-panel ${
                  optionsList?.length > 2 ? "bordered" : ""
                }`}
              >
                {optionsList?.length > 2 && (
                  <div className="options-list-header-txt">
                   <Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.SELECT_RELEVANT_OPTION,{lng:tgtLangST})}</Trans>
                  </div>
                )}
                <div className="options-list-btn-container">
                  {(optionsList || []).map(
                    (item, i) =>
                      item.option !== "Previous Menu" &&
                      item.option !== "Main Menu" && (
                        <button
                        className="options-list-btn"
                          // className={`options-list-btn ${
                          //   item.option === "Previous Menu"
                          //     ? "prevButton"
                          //     : null
                          // } ${
                          //   item.option === "Main Menu" ? "menuButton" : null
                          // } `}

                          key={i}
                          onClick={() => sendMessage(item)}
                        >
                          {item.option}
                        </button>
                      )
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="bottom-options-list-section">
        <div>
          {!loading && (
            <Button
              onClick={() => handleArrowClick("left")}
              disabled={!showLeftArrow}
              size="small"
              shape="circle"
              icon={<LeftOutlined />}
            />
          )}
        </div>
        <div
          style={{
            overflowX: "hidden",
            whiteSpace: "nowrap",
          }}
          ref={containerRef}
        >
          {!loading && (
            <>
              {faqDetails.map((item, index) => (
                <button
                  className="options-list-btn "
                  key={index}
                  size="small"
                  onClick={() => sendMessage(item)}
                >
                  {item.option}
                </button>
              ))}
            </>
          )}
        </div>
        <div>
          {!loading && (
            <Button
              onClick={() => handleArrowClick("right")}
              disabled={!showRightArrow}
              size="small"
              shape="circle"
              icon={<RightOutlined />}
            />
          )}
        </div>
      </div>

      {!loading && (
        <div className="chat-footer-AI">
          <Input.Search
            className="chat-input-search"
            autoFocus
            placeholder={t(CONSTANTS.TYPE_NEW_MESSAGE,{lng:tgtLang})}
            value={srchText}
            disabled={sendingMsg}
            onChange={(event) => setSrchText(event.target.value)}
            onPressEnter={() => sendMessage()}
            enterButton={sendingMsg ? <LoadingOutlined /> : <SendOutlined />}
            onSearch={() => sendMessage()}
          />
        </div>
      )}
    </div>
  );
};

export default AIBotChat;
